import React, { useEffect, useState } from "react";
import PageHeader from "../../shared/PageHeader";
import { FaArrowLeft } from "react-icons/fa6";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useFetchData from "../../hooks/UseFetchData";
import CustomTable from "../../shared/CustomTable";
import {
  LabOrderItemsColumns,
  labOrderItemsData,
} from "../../constants/LabOrderConstansts";
import { FaArrowRight, FaDownload } from "react-icons/fa";
import { fetchData } from "../../helpers/fetchData";
import toast from "react-hot-toast";
import PrintLabReportModal from "./PrintLabReportModal";

function ViewLabOrder() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [selectedModalData, setSelectedModalData] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const { t,i18n } = useTranslation();
  const location = useLocation();
  const radiology = location?.state?.radiology || false;
  const MainData = location?.state?.rowData || {};
  const data = location?.state?.rowData?.order_items || [];

  const actionTempelate = (rowData) => {
    return (
      <div className="flex gap-2">
        <FaDownload
          className="cursor-pointer text-primary"
          size={18}
          onClick={async () => {
            let res;
            setLoading(true);
            setSelectedItemId(rowData?.id);
            setSelectedItem(rowData);
            console.log(rowData?.progess_status);

            if (radiology ? rowData?.progess_status !== "completed" : rowData?.progess_status !== "approved") {
              toast.error("result is not uploaded yet");
              setLoading(false);
              return;
            }
            try {
              if (rowData?.item_type === "INTERNAL" && (radiology ? rowData?.progess_status === "completed" : rowData?.progess_status === "approved")) {
                {
                  if (radiology) {
                    res = await fetchData(
                      "POST",
                      `/v3/radiology/getUploadResults`,
                      {
                        item_id: rowData?.id,
                        order_no: MainData?.order_no,
                      }
                    );
                  } else {
                    res = await fetchData(
                      "POST",
                      "/v3/lab/getUploadResults",
                      {
                        item_id: rowData?.id,
                        order_no: MainData?.order_no,
                      }
                    );
                  }
                }
              } else {
                res = await fetchData(
                  "POST",
                  radiology ? "/v3/radiology/getUploadResults" : "/v3/lab/getUploadResults",
                  {
                    item_id: rowData?.id,
                    order_no: MainData?.order_no,
                  }
                );
              }

              if (res?.status == 200) {
                setSelectedModalData(res?.data);
                setOpenModal(true);
              }
            } catch (err) {
              console.error(err);
              toast.error(t("Failed to fetch result"));
            } finally {
              setLoading(false);
            }
          }}
        />
      </div>
    );
  };

  const action = {
    header: t("Actions"),
    body: actionTempelate,
    headerCellClass: "!bg-gray-200",
  };
  const columns = [action, ...LabOrderItemsColumns(t)];

  return (
    <div className="main-page-container !overflow-y-auto scrollbar">
      <PageHeader
        title={radiology ? t("View Radiology Order") : t("View Lab Order")}
        iconSize={20}
        Icon={i18n.dir() === "ltr" ? FaArrowLeft : FaArrowRight}
        onIconClick={() => {
          navigate("/patient-profile/summary", {
            state: { tab: radiology ? 0 : 1 },
          });
        }}
      />

      <div className="mt-2 w-full h-full ">
        <CustomTable columns={columns} data={data} isLoading={loading} />
      </div>

      <PrintLabReportModal
        visible={openModal}
        setVisible={setOpenModal}
        selectedItem={selectedItem}
        itemId={selectedItemId}
        orderNo={MainData?.order_no}
        patient={MainData?.patient}
        practitioner={MainData?.practitioner}
        data={selectedModalData}
        radiology={radiology}
      />
    </div>
  );
}

export default ViewLabOrder;
